import React from "react";
import DoctorImg from "../../assets/FacilitySection.png";
import { div } from "framer-motion/client";

// Data object for amenities
const facilityData = {
  amenities: [
    "40 bedded Medical care & supervision",
    "Therapy sessions (individual, group, family)",
    "Counseling and support groups",
    "Holistic therapies (yoga, meditation, art, music)",
    "Fitness and wellness programs",
    "Nutritional guidance and meal planning",
    "Private or shared accommodations",
    "24/7 support and monitoring",
  ],
  additionalAmenities: [
    "Recreational activities like indoor games, music, art/craft activities",
    "Educational programs",
    "Aftercare planning and support",
  ],
};

// Component for main amenities
const AmenitiesList = ({ items }) => {
  return (
    <ul className=" md:w-[700px] w-full  font-generalsans-subheading leading-[110%] text-[#2C3075]">
      {items.map((item, index) => (
        <div className="py-[24px] border-b   border-[#2C3075]">
          <li key={index}>{item}</li>
        </div>
      ))}
    </ul>
  );
};

// Component for additional amenities
const AdditionalAmenities = ({ items }) => {
  return (
    <>
      <h3 className="md:my-6  md:w-[700px] w-full md:mt-[80px] mt-[55px] mb-[0]   font-generalsans-subheading leading-[110%] text-[#2C3075]">
        <strong> We offer additional amenities like:
        </strong>
      </h3>
      <ul className=" md:w-[700px] w-full  font-generalsans-subheading text-[#2C3075] mt-2">
        { items.map( ( item, index ) => (
          <div className="py-[24px] border-b  border-[#2C3075]">

            <li  key={index}>{item}</li>
          </div>
        ))}
      </ul>
    </>
  );
};

const FacilitySection = () => {
  return (
    <section className="w-full md:mb-[90px] mb-[40px] md:px-[75px] px-6  py-12">
      <div className="grid grid-cols-12 gap-5">
        {/* Headline */}
        <div className="col-span-12 ">
          <h2 className="font-garamond-subheading-facility font-semibold text-[#2C3075] leading-[110%] mb-6 ">
            Our center provides various facilities to support patient recovery,
            including:
          </h2>
          <hr className=" md:hidden block border-b   border-[#2C3075]" />
        </div>

        {/* Left Content */}
        <div className="col-span-12 md:col-span-7 lg:col-span-8">
          <AmenitiesList  items={facilityData.amenities} />
          <AdditionalAmenities   items={facilityData.additionalAmenities} />
        </div>

        {/* Right Image (hidden on mobile) */}
        <div className="w-[434px] h-[616px] bg-transparent rounded-[100px] col-span-12 md:col-span-5 lg:col-span-4 hidden md:flex justify-center md:justify-end">
          <img
            src={DoctorImg}
            alt="Doctor holding stethoscope"
            className="w-full h-full rounded-lg object-cover"
          />
        </div>
      </div>
    </section>
  );
};

export default FacilitySection;
